import {AiPromptBoxVariant, PromptBoxConfigOptionType} from '@Components/ai-text-prompt-box/ai-text-prompt-box.types';
import type {EmailMakerAiTextPromptBoxProps} from '@Components/email-maker-ai-text-prompt-box/email-maker-ai-text-prompt-box';
import type {PrimaryConfigOptions} from '@/email-maker/grapesjs-email-editor-plugin/src';
import {EmailEditorAiPromptBoxVariant} from '@Libraries/ai-email-campaign-content-library';

export default (opt: PrimaryConfigOptions): void => {
  const {editor} = opt;
  const styleManager = editor.StyleManager;

  styleManager.addType(window.PMW.emails.styles.ID_AI_REWRITE_PROMPT_BOX, {
    create(): HTMLDivElement {
      const aiRewritePromptBoxContainer = document.createElement('div');

      window.PMW.renderAiRewritePromptBox(aiRewritePromptBoxContainer, getOpts());
      return aiRewritePromptBoxContainer;
    },
  });

  styleManager.addType(window.PMW.emails.styles.ID_SINGLE_COMPONENT_AI_REWRITE_PROMPT_BOX, {
    create(): HTMLDivElement {
      const singleTextAiRewritePromptBoxContainer = document.createElement('div');

      window.PMW.renderAiRewritePromptBox(
        singleTextAiRewritePromptBoxContainer,
        getBasicOpts(
          EmailEditorAiPromptBoxVariant.SINGLE_TEXT_EDITOR,
          window.i18next.t('pmwjs_write_a_prompt_to_update_content_ellipsis'),
          window.i18next.t('pmwjs_ai_writer'),
          window.i18next.t('pmwjs_generate')
        )
      );
      return singleTextAiRewritePromptBoxContainer;
    },
  });

  const getBasicOpts = (
    emailEditorAiPromptBoxVariant: EmailEditorAiPromptBoxVariant = EmailEditorAiPromptBoxVariant.TEMPLATE_EDITOR,
    mainPlaceholder: string = window.i18next.t('pmwjs_describe_email_content'),
    headerLabel: string = window.i18next.t('pmwjs_content'),
    defaultHeaderButtonText = window.i18next.t('pmwjs_ai_writer')
  ): Omit<EmailMakerAiTextPromptBoxProps, 'rewriteContent'> => {
    return {
      optionsToUse: [PromptBoxConfigOptionType.EMAIL_CAMPAIGN_SUBJECT_TONE, PromptBoxConfigOptionType.PURPOSE, PromptBoxConfigOptionType.EMOJIS],
      isInMobileMode: true,
      variant: AiPromptBoxVariant.MINIATURE,
      mainPlaceholder,
      editor,
      emailEditorAiPromptBoxVariant,
      headerLabel,
      defaultHeaderButtonText,
    };
  };

  const getOptsWithAutoUpdateTextContentParams = (): Omit<EmailMakerAiTextPromptBoxProps, 'rewriteContent'> => {
    const autoUpdateTextContentParams = window.PMW.emails.AUTO_UPDATE_EMAIL_CONTENT_PARAMS?.autoUpdateTextContentParams;

    return {
      ...getBasicOpts(),
      defaultPrompt: autoUpdateTextContentParams?.rewriteContentPrompt,
      defaultGenerationOptions: autoUpdateTextContentParams?.rewriteContentPromptOptions,
    };
  };

  const getOpts = (): Omit<EmailMakerAiTextPromptBoxProps, 'rewriteContent'> => {
    const autoUpdateTextContentParams = window.PMW.emails.AUTO_UPDATE_EMAIL_CONTENT_PARAMS?.autoUpdateTextContentParams;

    return autoUpdateTextContentParams ? getOptsWithAutoUpdateTextContentParams() : getBasicOpts();
  };
};
